import React from 'react'

const TableLineDisable = function ({ line, item = null }) {
  if ((line && line.active === false) || (typeof line.active === 'string' && line.active.toUpperCase() === 'INATIVO')) {
    return <div style={{ fontStyle: 'italic', color: 'darkgray' }}>{item}</div>
  }

  return item
}

export { TableLineDisable }
